import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Guardian } from 'src/app/_models/guardian';
import { AdminService } from './../../_services/admin.service';

@Component({
  selector: 'app-enrol-admin-extend',
  templateUrl: './enrol-admin-extend.component.html',
  styleUrls: ['./enrol-admin-extend.component.css']
})
export class EnrolAdminExtendComponent implements OnInit {
  myForm;
  @Input() studentDetail:any={}
  @Input() guardian = new Guardian()
  @Input() enrolment_extend_id=0
  @Output() closeModalRequest= new EventEmitter<string>()
  extending = false
  constructor(private adminService:AdminService) { }

  ngOnInit(): void {
    this.myForm = new FormGroup({
      days: new FormControl("", [Validators.required])
    })
  }
  closeModal(){
    this.closeModalRequest.emit("enrolAdminExtendModal")
 }

 on_submit() {
  this.adminExtendEnrolment()

}
formatData(formData) {
  let data = new URLSearchParams();
  data.set('days', formData.days);
  return data.toString()
}


adminExtendEnrolment(){
  let data = this.formatData(this.myForm.value)
  this.extending =true
  this.adminService.extendEnrolment(data, this.enrolment_extend_id).subscribe(
    x=>{
       if(x){
        this.extending=false
        this.closeModalRequest.emit("adminEnrolExtendModal")
       }
    }
  )
}

}
